import { useController, useWatch } from 'react-hook-form'
import { useQuestionVisibility } from '@core/providers/useQuestionVisibility'
import { ITemplateRule } from '@core/entities/template/TemplateRule'
import { ITemplateQuestionGroup } from '@core/entities/template/TemplateQuestionGroup'
import { useDeepCompareEffect } from 'use-deep-compare'

const HiddenQuestionsController = () => {
  const questions = useWatch({
    name: 'questions',
  }) as Array<ITemplateQuestionGroup>
  const rules = useWatch({
    name: 'rules',
  }) as Array<ITemplateRule>

  // The project the permit is being raised in — used to evaluate PROJECT_IS_IN conditions
  const currentProjectId = useWatch({ name: 'projectId' }) as number

  const {
    field: { onChange },
  } = useController({
    name: 'hiddenQuestionIds',
  })

  const { hiddenQuestionIds } = useQuestionVisibility({
    questions,
    rules,
    currentProjectId,
  })

  useDeepCompareEffect(() => {
    if (rules) onChange(hiddenQuestionIds)
  }, [hiddenQuestionIds, onChange, rules])

  return null
}

export { HiddenQuestionsController }
